var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    height: "16px",
    width: "16px",
    style: {
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1029 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M877.216 491.808"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M703.84 479.936l-191.872 0L511.968 224.096C511.968 206.368 497.728 192 480 192c-17.76 0-32 14.4-32 32.096l0 287.808c0 17.76 14.272 32 32 32l223.872 0c17.76 0 32.096-14.24 32.096-32C735.968 494.176 721.6 479.936 703.84 479.936L703.84 479.936z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1028.128 834.368"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M224 320 128 320 128 224c0-17.664-14.336-32-32-32S64 206.336 64 224l0 128c0 17.664 14.336 32 32 32l128 0c17.664 0 32-14.336 32-32C256 334.336 241.664 320 224 320z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M139.008 603.488C136 584 123.264 573.344 105.6 573.344c-17.664 0-30.112 13.984-30.112 31.68 0 5.536 1.984 9.984 2.336 15.328C126.336 815.296 302.016 960 512 960c247.424 0 448-200.576 448-448S759.424 64 512 64C321.024 64 158.4 183.712 93.952 352l69.312 0C223.968 219.904 357.088 128 512 128c212.064 0 384 171.936 384 384s-171.936 384-384 384c-178.88 0-328.736-122.464-371.424-288"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/history-icon.931dcc53706931ef4bca0574d3480d63.svg";
export { ForwardRef as ReactComponent };